import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { SectionHeader, Panel, FieldRow } from "@/components/admin/common";

const FIELDS = [
  ["phone", "Phone"],
  ["email", "Email"],
  ["address_line1", "Address line 1"],
  ["address_line2", "Address line 2 (city)"],
  ["postcode", "Postcode"],
  ["country", "Country"],
];

export default function AdminContactInfo({ value, onChange, onSave, saving }) {
  const v = value || {};
  const update = (k, val) => onChange({ ...v, [k]: val });

  return (
    <div>
      <SectionHeader
        title="Contact info"
        description="Phone, email, address and map embed — shown in the Contact section and the footer."
        onSave={() => onSave(v)}
        saving={saving}
      />
      <Panel>
        <FieldRow>
          {FIELDS.map(([k, l]) => (
            <div key={k}>
              <Label>{l}</Label>
              <Input
                data-testid={`admin-contact-${k}`}
                value={v[k] || ""}
                onChange={(e) => update(k, e.target.value)}
                className="h-11 rounded-xl mt-1"
              />
            </div>
          ))}
        </FieldRow>
        <div className="mt-5">
          <Label>Google Maps embed URL</Label>
          <Textarea
            data-testid="admin-contact-maps"
            value={v.maps_embed || ""}
            onChange={(e) => update("maps_embed", e.target.value)}
            rows={3}
            className="rounded-xl mt-1 font-mono text-xs"
            placeholder="https://www.google.com/maps/embed?pb=..."
          />
          <p className="mt-2 text-xs text-[#5C534D]">
            From Google Maps: click <em>Share → Embed a map</em> and paste the
            URL from the <code>src</code> attribute.
          </p>
        </div>
      </Panel>
    </div>
  );
}
